<template>
  <div class="box">
    <div class="box_item title">{{ title }}</div>
    <div
      @click="changeIndex(i, item)"
      class="box_item box_item_cursor"
      :class="index == i ? 'box_item_select' : ''"
      v-for="(item, i) in titleList"
    >
      {{ item.name }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: "",
    titleList: [],
  },
  data() {
    return {
      index: 0,
    };
  },
  methods: {
    changeIndex(i) {
      this.index = i;
      this.$emit("changeIndex", i);
    },
  },
};
</script>

<style scoped>
.box {
  border: 1px solid #d9d9d9;
  border-radius: 4px;
}

.title {
  background-color: #096dd9;
  font-weight: 700;
  color: #ffffff;
}

.box_item {
  text-align: center;
  height: 30px;
  line-height: 30px;
  padding: 10px;
  font-size: 16px;
  border: 1px solid #d9d9d9;
}

.box_item_cursor {
  cursor: pointer;
}

.box_item_cursor:hover {
  color: #096dd9;
}

.box_item_select {
  color: #096dd9 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/designPage/template/components/title_list_component.vue